import React from 'react';
import Motif from "pages/createMission/body/motif";
import Period from "pages/createMission/body/period";
import Confirmation
    from "pages/createMission/body/confirmation";
import End from "pages/createMission/body/end";
import UseContext from "hooks/useContext";
import Invitation from "./body/invitation";
import Activity from "pages/createMission/body/activity";
import Prerequis from "pages/createMission/body/prerequis";
import Location from "pages/createMission/body/location";
import Salary from "pages/createMission/body/salary";
import Contact from "pages/createMission/body/contact";
import Other from "pages/createMission/body/other";

// La création de mission commence au motif ; la fiche est choisie avant (liste / modal « Utiliser cette fiche »).
const FormsCreate = () => {
    const {page} = UseContext()
    const display = {
        1: <Activity key={'activity'}/>,
        2: <Prerequis key={'prerequis'}/>,
        3: <Motif key={'motif'}/>,
        4: <Location key={'location'}/>,
        5: <Period key={'period'}/>,
        6: <Salary key={'salary'}/>,
        7: <Invitation key={'invitation'}/>,
        8: <Contact key={'contact'}/>,
        9: <Other key={'other'}/>,
        10: <Confirmation key={'confirmation'}/>,
        11: <End key={'end'}/>
    }

    return (
        <>
            {display[page]}
        </>
    );
};

export default FormsCreate;
